import { Component } from "react";
import CustomizedSelect from "./customizedSelect";
import { Input } from "../../forms/input";
import Signbutton, { Debtbutton } from "../../forms/button";
import { connect } from "react-redux";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import {
  YES,
  EXISTING,
  NEW,
  REGULAR,
  PURCHASE,
  NO,
  ADDITIONAL_PURCHASE,
  SUBMIT,
  addToCart,
  singleTransaction,
} from "../../../store/types";
import MenuItem from "@material-ui/core/MenuItem";
import { Checkbox } from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {
  validateSubBroker,
  getAssetClasses,
  getOtherSchemes,
  submitPurchaseData,
  showPurchaseConfirmation,
  additionalPurchase,
  addItemsToCart,
} from "../../../store/actions";
import IntegrationReactSelect from "../../forms/autoCompleteInput";
import { NEW_TRANSACTION_URL } from ".";
import CustomLoader from "../../forms/Loader";
import { AddToCartStatusModal } from "../customModal";
const LIC_MUTUALFUND = "102";
const TRUST_MUTUALFUND = "185";
const cartDisabledFunds = [LIC_MUTUALFUND, TRUST_MUTUALFUND];
class AdditionalPurchase extends Component {
  constructor(props) {
    super(props);
    const { fundList, location } = this.props;
    const { state } = location;
    const { transaction } = state;
    const funds = fundList.reduce((prev, curr) => {
      if (curr.pFlag === YES) {
        const findIndex =
          prev.findIndex((fund) => fund.Fund === curr.Fund) !== -1;
        if (!findIndex) {
          return [...prev, { Fund: curr.Fund, FundDesc: curr.FundDesc }];
        }
      }
      return prev;
    }, []);
    let finalObj = {};
    if (!!transaction) {
      const schemes = (folio) => {
        return this.props.fundList.reduce((prev, curr) => {
          if (curr.Acno === folio) {
            return [...prev, curr];
          }
          return prev;
        }, []);
      };
      const resultschemes = schemes(transaction.Folio);
      for (let i = 0; i < resultschemes.length; i++) {
        Object.assign(finalObj, resultschemes[i]);
      }
    }
    this.state = {
      funds,
      fund: {
        value: !!transaction
          ? { label: transaction.fund, value: transaction.fund_code }
          : "",
      },
      folios: [],
      folio: {
        value: !!transaction
          ? { label: transaction.Folio, value: transaction.Folio }
          : "",
      },
      schemes: [],
      schemeType: EXISTING,
      combo: { flag: "", disclamier: "", label: "" },
      isCombo: false,
      scheme: {
        value: !!transaction
          ? { label: transaction.scheme_descrption, value: finalObj }
          : "",
      },
      radioValue: {
        value: "yes", //!!transaction && transaction.euinopt === "Y" ? "yes" : "no",
      },
      arnCode: { value: this.props.token },
      subArnCode: { value: "" },
      subBrokerCode: { value: "" },
      euinNo: {
        value:
          !!transaction && transaction.euinopt == "N"
            ? transaction.euin_code
            : "",
      },
      category: { value: "" },
      bank: { value: "" },
      categories: [],
      banks: [],
      amount: { value: !!transaction ? transaction.amount : "" },
      showSmart: false,
      smart: { flag: "yes" },
      display: false,
      PosterOpen: false,
      openeuin: true,
      radioValueforpayment: { value: "no" },
      reference_Number: { value: "" },
      erroreuin: false,
    };
  }
  async componentDidMount() {
    this.setState({
      display: true,
    });
    const { fundList, location } = this.props;
    if (!!location.state.transaction) {
      const fund = location.state.transaction.fund_code;
      const folios = fundList.reduce((prev, curr) => {
        if (curr.pFlag === YES && curr.Fund === fund) {
          return [...prev, curr.Acno];
        }
        return prev;
      }, []);
      this.setState({
        folios: Array.from(new Set(folios)),
      });
      if (!!fund) {
        this.validateBrokerCode(fund)();
      }
      const folio = location.state.transaction.Folio;
      const schemes = this.props.fundList.reduce((prev, curr) => {
        if (curr.Acno === folio) {
          return [...prev, curr];
        }
        return prev;
      }, []);
      this.setState({
        schemes,
      });
    }
    this.setState({
      display: false,
    });
  }

  handleFundChange = (value) => {
    // if(!!value && !!value.value && (String(value.value).trim() === "176" || String(value.value).trim() === "103")){
    //   this.setState({
    //     PosterOpen:true
    //   })
    // }
    if (!value) {
      this.setState({
        fund: { value: "" },
        folios: [],
        folio: { value: "" },
        scheme: { value: "" },
        schemeType: EXISTING,
        subArnCode: { value: "" },
        subBrokerCode: { value: "" },
        euinNo: { value: "" },
        category: { value: "" },
        // bank: { value: "" },
        showSmart: false,
        amount: { value: "" },
      });
      return;
    } else if (value.value === this.state.fund.value.value) {
      return;
    } else {
      const fund = value.value;
      const folios = this.props.fundList.reduce((prev, curr) => {
        if (curr.pFlag === YES && curr.Fund === fund) {
          return [...prev, curr.Acno];
        }
        return prev;
      }, []);
      this.setState({
        fund: { value },
        folios: Array.from(new Set(folios)),
        folio: { value: "" },
        schemes: [],
        scheme: { value: "" },
        schemeType: EXISTING,
        subArnCode: { value: "" },
        subBrokerCode: { value: "" },
        euinNo: { value: "" },
        category: { value: "" },
        // bank: { value: "" },
        showSmart: false,
        amount: { value: "" },
      });
      if (!!fund) {
        this.validateBrokerCode(fund)();
      }
    }
  };

  validateBrokerCode = (fund) => async () => {
    const { subArnCode, arnCode } = this.state;
    this.setState({
      euinNo: { value: "" },
    });
    if (
      !!this.state.subArnCode.value &&
      this.state.subArnCode.value === this.state.arnCode.value.split("-")[1]
    ) {
      this.setState({
        subArnCode: {
          value: "",
          isError: true,
          errorMessage: "ARN and Sub ARN Code should not be the same",
        },
      });
      return;
    }
    const params = {
      Fund: fund,
      SubAgentCd: !!subArnCode.value ? `ARN-${subArnCode.value}` : "",
      AgentCd: arnCode.value,
    };
    const response = await this.props.validateSubBroker(params);
    if (!!response && !!response.DtData && response.DtData.length > 0) {
      const getLength = response.DtData.length === 1;
      if (!!getLength) {
        this.setState({
          euinNo: { value: response.DtData[0].abm_agent },
        });
      }
    }

    if (!response) {
      this.setState({
        subArnCode: {
          value: "",
          isError: true,
          errorMessage: `(Please enter a valid Sub ARN Code)`,
        },
      });
    }
  };

  closePoster = () => {
    this.setState({
      PosterOpen: false,
    });
  };

  handleFolioChange = (value) => {
    if (!value) {
      this.setState({
        folio: { value: "" },
        schemes: [],
        schemeType: EXISTING,
        banks: [],
        scheme: { value: "" },
        // bank: { value: "" },
        subArnCode: { value: "" },
        subBrokerCode: { value: "" },
        euinNo: { value: "" },
        category: { value: "" },
        amount: { value: "" },
        showSmart: false,
      });
      return;
    } else if (value.value === this.state.folio.value.value) {
      return;
    } else {
      const folio = value.value;
      const schemes = this.schemes(folio);
      const banks = this.props.bankDetails.filter(
        (item) => item.foliono === folio
      );
      this.setState({
        folio: { value },
        schemes,
        schemeType: EXISTING,
        banks,
        showSmart: false,
        scheme: { value: "" },
        // bank: { value: "" },
      });
    }
  };

  changeEuin = (value) => {
    this.setState({
      euinNo: { value },
    });
  };

  changeValue = (label) => (event) => {
    if (label === "amount" && event.target.value.length <= 10) {
      this.setState({
        [label]: { value: event.target.value.replace(/^0+/, "") },
      });
    } else if (label === "reference_Number") {
      if (!/^[sS]\d{8}$/.test(event.target.value)) {
        this.setState({
          [label]: {
            value: event.target.value,
            isError: true,
            errorMessage: "Please enter a valid reference number",
          },
        });
      } else {
        this.setState({
          [label]: { value: event.target.value },
        });
      }
    } else if (label === "radioValueforpayment") {
      this.setState({
        radioValueforpayment: { value: event.target.value },
      });
    } else if (
      (label === "subArnCode" || label === "subBrokerCode") &&
      event.target.value.length <= 20
    ) {
      this.setState({
        [label]: { value: event.target.value },
      });
    } else if (label === "radioValue" && event.target.value === "yes") {
      if (this.props.euinList.length === 1) {
        this.setState({
          euinNo: { value: this.props.euinList[0].abm_agent },
        });
      }
      this.setState({
        radioValue: { value: event.target.value },
      });
    }

    //  else if (label === "bank") {
    //   this.setState({
    //     [label]: { value: event.target.value },
    //   });
    // }
    else if (
      label !== "amount" &&
      label !== "subArnCode" &&
      label !== "subBrokerCode" &&
      label === "radioValue" &&
      event.target.value !== "yes"
    ) {
      this.setState({
        [label]: { value: event.target.value },
      });
    }
  };

  getAssetClasses = async () => {
    const params = {
      Fund: this.state.fund.value.value,
      Folio: this.state.folio.value.value,
    };
    const assetClasses = await this.props.getAssetClasses(params);
    if (assetClasses) {
      this.setState({
        categories: assetClasses.DtData,
      });
    }
  };

  getOtherSchemes = async (value) => {
    const params = {
      schtype: REGULAR,
      category: value,
      acno: this.state.folio.value.value,
      fundCode: this.state.fund.value.value,
      trantype: PURCHASE,
    };
    const otherSchemes = await this.props.getOtherSchemes(params);
    if (otherSchemes) {
      this.setState({
        schemes: otherSchemes.DtData,
      });
    }
  };

  schemes = (folio) => {
    return this.props.fundList.reduce((prev, curr) => {
      if (
        curr.pSchFlg === YES &&
        curr.Fund === this.state.fund.value.value &&
        curr.Acno === folio
      ) {
        return [...prev, curr];
      }
      return prev;
    }, []);
  };

  handleCategoryChange = (event) => {
    if (event.target.value) {
      this.getOtherSchemes(event.target.value);
      this.setState({
        category: { value: event.target.value },
        scheme: { value: "" },
        showSmart: false,
      });
    } else {
      this.setState({
        category: { value: "" },
        scheme: { value: "" },
        showSmart: false,
      });
    }
  };

  showError = (label) => (event) => {
    const {
      [label]: { value },
    } = this.state;
    if (label === "reference_Number") {
      if (!/^[sS]\d{8}$/.test(value)) {
        this.setState({
          [label]: {
            value: "",
            isError: true,
            errorMessage: "Reference Number should not be more than 8",
          },
        });
      } else {
        this.setState({
          [label]: { value },
        });
      }
    }
    if (label === "amount" && !event.target.value) {
      this.setState({
        amount: {
          ...this.state.amount,
          isError: true,
          errorMessage: "amount is mandatory*",
        },
      });
    }

    // if (label === "amount" && this.state.fund.value.value === "103") {
    //   const { amount, scheme, schemeType } = this.state;
    //   let SmartSchemes = ["103~LA~RD~R", "103~LA~RD~D", "103~LA~RG~G"];

    //   let constructScheme;
    //   if (schemeType === EXISTING) {
    //     const { Fund, Sch, Pln, Opt } = scheme.value.value;
    //     constructScheme = `${Fund}~${Sch}~${Pln}~${Opt}`;
    //   } else {
    //     const { fm_fund, fm_scheme, fm_plan, fm_option } = scheme.value.value;
    //     constructScheme = `${fm_fund}~${fm_scheme}~${fm_plan}~${fm_option}`;
    //   }

    //   if (
    //     !!SmartSchemes.includes(constructScheme) &&
    //     parseFloat(amount.value) >= 25000
    //   ) {
    //     this.setState({
    //       showSmart: true,
    //       smart: { flag: "yes" },
    //     });
    //   } else if (
    //     !!SmartSchemes.includes(constructScheme) &&
    //     (!amount.value || (!!amount.value && parseFloat(amount.value) <= 25000))
    //   ) {
    //     this.setState({
    //       showSmart: false,
    //       smart: { flag: "no" },
    //     });
    //   }
    // } else {
    this.setState({
      [label]: {
        value,
        isError: !value,
      },
    });
    // }
  };
  changeSchemeType = (value) => () => {
    if (value === this.state.schemeType) {
      return;
    }
    if (value === EXISTING) {
      const schemes = this.schemes(this.state.folio.value.value);
      this.setState({
        schemeType: value,
        schemes,
        category: { value: "" },
        scheme: { value: "" },
        amount: { value: "" },
        showSmart: false,
      });
    } else {
      this.setState({
        schemeType: value,
        scheme: { value: "" },
        category: { value: "" },
        amount: { value: "" },
        showSmart: false,
      });
      if (!!this.state.fund.value && !!this.state.folio.value) {
        this.getAssetClasses();
        this.getOtherSchemes();
      }
    }
  };

  handleSchemeChange = (value) => {
    if (!value) {
      this.setState({
        scheme: { value: "" },

        scheme: { value: "" },
        // bank: { value: "" },
        subArnCode: { value: "" },
        subBrokerCode: { value: "" },
        euinNo: { value: "" },
        amount: { value: "" },
        showSmart: false,
      });
      return;
    } else if (
      !!value &&
      !!this.state.scheme.value &&
      value.value === this.state.scheme.value.value
    ) {
      return;
    } else {
      const scheme = value.value;
      const checkCombo =
        !!scheme && !!scheme.combo_flag && scheme.combo_flag === "Y";
      this.setState({
        scheme: { value },
        minAmount: scheme.MinAmt || scheme.fm_newpur,
        amount: { value: "" },
        isCombo: false,
        combo: {
          flag: !!checkCombo ? "Y" : "N",
          disclamier: scheme.combo_disclaimer,
          label: scheme.combo_lable,
        },
        // bank: { value: "" },
        subArnCode: { value: "" },
        subBrokerCode: { value: "" },
        showSmart: false,
      });
    }
  };

  changeSmart = (event) => {
    this.setState({
      smart: { flag: event.target.value },
    });
  };
  euinitem = (item) => {
    this.setState({
      euinNo: { value: item },
      openeuin: false,
    });
  };

  submit = async () => {
    const {
      funds,
      categories,
      smart,
      erroreuin,
      radioValueforpayment,
      reference_Number,
      showSmart,
      schemes,
      folios,
      banks,
      arnCode,
      subArnCode,
      subBrokerCode,
      radioValue,
      euinNo,
      minAmount,
      schemeType,
      category,
      bank,
      openeuin,
      isCombo,
      PosterOpen,
      combo,
      display,
      ...others
    } = this.state;

    const keys = Object.keys(others);

    if (this.state.schemeType === NEW && this.state.category.value === "") {
      this.setState({
        category: {
          value: "",
          isError: true,
          errorMessage: "(category is mandatory*)",
        },
      });
    }
    if (
      !this.state.reference_Number.value &&
      this.state.fund.value.value === "178" &&
      this.props.token === "ARN-35783" &&
      this.state.radioValueforpayment.value === "Y"
    ) {
      this.setState({
        reference_Number: {
          value: "",
          isError: true,
          errorMessage: "Reference Number is mandatory*",
        },
      });
      return;
    }
    if (
      this.state.fund.value.value === "178" &&
      this.props.token === "ARN-35783" &&
      !/^[sS]\d{8}$/.test(this.state.reference_Number.value) &&
      this.state.radioValueforpayment.value === "Y"
    ) {
      this.setState({
        reference_Number: {
          value: "",
          isError: true,
          errorMessage: "Enter a valid reference number*",
        },
      });
      return;
    }
    const findError = keys.every((key) => !!others[key].value);
    const arn = this.state.arnCode.value.split("-");
    if (!findError) {
      keys.forEach((key) => {
        !others[key].value &&
          this.setState({
            [key]: {
              ...others[key],
              isError: true,
              errorMessage: `${key} is mandatory*`,
            },
          });
      });
      const firstErroredKey = keys.find((key) => !others[key].value);
      switch (firstErroredKey) {
        case "fund": {
          this.fundField.focus();
          break;
        }
        case "folio": {
          this.folioField.focus();
          break;
        }
        case "scheme": {
          this.schemeField.focus();
          break;
        }
        case "amount": {
          this.amountField.focus();
          break;
        }
        // case "bank": {
        //   this.bankField.focus();
        //   break;
        // }
      }
    } else if (schemeType === NEW && !category.value) {
      this.setState({
        category: { ...category, isError: true },
      });
      this.categoryField.focus();
      return;
    } else if (radioValue.value === "yes" && !euinNo.value) {
      this.setState({
        euinNo: {
          value: "",
        },
        erroreuin: true,
      });
      return;
    } else if (
      !!others.amount.value &&
      parseFloat(minAmount) > parseFloat(others.amount.value)
    ) {
      this.setState({
        amount: {
          ...others["amount"],
          isError: true,
          errorMessage: `(Amount should be ${minAmount}INR)`,
        },
      });
      this.amountField.focus();
      return;
    } else if (arn[1] === this.state.subArnCode.value) {
      this.setState({
        subArnCode: {
          value: "",
          isError: true,
          errorMessage: `and ARN code should  not match `,
        },
      });
    } else {
      if (!!this.state.isCombo && this.state.combo.flag === "Y") {
        if (
          window.confirm(
            "You have opted to do a Purchase cum Switch. Do you want to proceed?"
          )
        ) {
        } else {
          return;
        }
      }
      this.setState({
        display: true,
      });
      const { communicationDetails, investorData } = this.props;
      const Xmobile = communicationDetails.find(
        (detail) =>
          detail.Fund === this.state.fund.value.value &&
          detail.Acno === this.state.folio.value.value &&
          detail.PAN === investorData.PAN &&
          !!detail.Mobile
      );
      const Xemail = communicationDetails.find(
        (detail) =>
          detail.Fund === this.state.fund.value.value &&
          detail.Acno === this.state.folio.value.value &&
          detail.PAN === investorData.PAN &&
          !!detail.email
      );

      const Email = !!Xemail && !!Xemail.email ? Xemail.email : "";
      const Mobile = !!Xmobile && !!Xmobile.Mobile ? Xmobile.Mobile : "";

      const params = {
        InvestorName: investorData.invname,
        i_entby: this.props.userId,
        trtype: PURCHASE,
        Desci: "Yes~A~",
        SubbrokerArn: !!this.state.subArnCode.value
          ? `ARN-${subArnCode.value}`
          : "",
        ARNCode: this.state.arnCode.value,
        EuinCode:
          this.state.radioValue.value === "yes" ? this.state.euinNo.value : "",
        i_Userid: this.props.userId,
        Mobile: Mobile,
        PanNo: investorData.PAN || this.props.user_pan,
        Email: Email,
        i_Acno: this.state.folio.value.value,

        Subbroker: this.state.subBrokerCode.value,
        i_Fund: this.state.fund.value.value,
        i_UntAmtValue: this.state.amount.value,
        EUINFlag: this.state.radioValue.value === "yes" ? NO : YES,
        EuinValid: this.state.radioValue.value === "yes" ? NO : YES,
        // Bankid: `${this.state.bank.value.bnkcode}~${this.state.bank.value.bnkactype}~${this.state.bank.value.bnkacno}`,
        i_Scheme:
          this.state.scheme.value.value.Sch ||
          this.state.scheme.value.value.fm_scheme,
        i_Plan:
          this.state.scheme.value.value.Pln ||
          this.state.scheme.value.value.fm_plan,
        i_Option:
          this.state.scheme.value.value.Opt ||
          this.state.scheme.value.value.fm_option,
        i_oldihno: "0",
        i_InvDistFlag: "W",
        ModuleName: "Webile",
        comboswitch: !!this.state.isCombo ? "Y" : "N",
        bob_pio_flag: this.state.radioValueforpayment.value,
        bob_pio_refno: this.state.reference_Number.value,
        displayBOP:
          this.state.fund.value.value === "178" &&
          this.props.token === "ARN-35783",
        // smart_flag: !!showSmart && this.state.smart.flag === "yes" ? "Y" : "N",
      };

      const response = await this.props.submitPurchaseData(params);
      if (response) {
        const {
          DtData: [purchaseData],
        } = response;
        const confirmationParams = {
          Trtype: PURCHASE,
          fund: this.state.fund.value.value,
          Refno: purchaseData.refno,
          ModuleName: "Webile",
        };
        const confirmationResponse = await this.props.showPurchaseConfirmation(
          confirmationParams
        );

        if (!!confirmationResponse) {
          this.props.history.push({
            pathname:
              NEW_TRANSACTION_URL +
              "/additional-purchase/digital/transact/confirm",
            state: {
              title: "ADDITIONAL PURCHASE SUMMARY",
              type: ADDITIONAL_PURCHASE,
              scheme: { Fund: this.state.fund.value.value },
              ARNCode: this.state.arnCode.value.split("-")[1],
              Folio: this.state.folio.value,
              folio: this.state.folio.value,
              methodType: this.state.schemeType,
              bob_pio_flag: this.state.radioValueforpayment.value,
              bob_pio_refno: this.state.reference_Number.value,
              displayBOP:
                this.state.fund.value.value === "178" &&
                this.props.token === "ARN-35783",
            },
          });
        }
      }
      this.setState({
        display: false,
      });
    }
  };

  onButtonClick = async (btnLabel) => {
    try {
      const {
        funds,
        openDialog,
        categories,
        smart,
        erroreuin,
        radioValueforpayment,
        reference_Number,
        showSmart,
        schemes,
        folios,
        banks,
        arnCode,
        subArnCode,
        subBrokerCode,
        radioValue,
        euinNo,
        minAmount,
        schemeType,
        category,
        bank,
        openeuin,
        isCombo,
        PosterOpen,
        combo,
        display,
        ...others
      } = this.state;

      const keys = Object.keys(others);

      if (this.state.schemeType === NEW && this.state.category.value === "") {
        this.setState({
          category: {
            value: "",
            isError: true,
            errorMessage: "(category is mandatory*)",
          },
        });
      }
      if (
        !this.state.reference_Number.value &&
        this.state.fund.value.value === "178" &&
        this.props.token === "ARN-35783"
      ) {
        this.setState({
          reference_Number: {
            value: "",
            isError: true,
            errorMessage: "Reference Number is mandatory*",
          },
        });
        return;
      }
      if (
        this.state.fund.value.value === "178" &&
        this.props.token === "ARN-35783" &&
        !/^[sS]\d{8}$/.test(this.state.reference_Number.value) &&
        this.state.radioValueforpayment.value === "Y"
      ) {
        this.setState({
          reference_Number: {
            value: "",
            isError: true,
            errorMessage: "Enter a valid reference number*",
          },
        });
        return;
      }
      const findError = keys.every((key) => !!others[key].value);
      const arn = this.state.arnCode.value.split("-");
      if (!findError) {
        keys.forEach((key) => {
          !others[key].value &&
            this.setState({
              [key]: {
                ...others[key],
                isError: true,
                errorMessage: `${key} is mandatory*`,
              },
            });
        });
        const firstErroredKey = keys.find((key) => !others[key].value);
        switch (firstErroredKey) {
          case "fund": {
            this.fundField.focus();
            break;
          }
          case "folio": {
            this.folioField.focus();
            break;
          }
          case "scheme": {
            this.schemeField.focus();
            break;
          }
          case "amount": {
            this.amountField.focus();
            break;
          }
          // case "bank": {
          //   this.bankField.focus();
          //   break;
          // }
        }
      } else if (schemeType === NEW && !category.value) {
        this.setState({
          category: { ...category, isError: true },
        });
        this.categoryField.focus();
        return;
      } else if (radioValue.value === "yes" && !euinNo.value) {
        this.setState({
          euinNo: {
            value: "",
          },
          erroreuin: true,
        });
        return;
      } else if (
        !!others.amount.value &&
        parseFloat(minAmount) > parseFloat(others.amount.value)
      ) {
        this.setState({
          amount: {
            ...others["amount"],
            isError: true,
            errorMessage: `(Amount should be ${minAmount}INR)`,
          },
        });
        this.amountField.focus();
        return;
      } else if (arn[1] === this.state.subArnCode.value) {
        this.setState({
          subArnCode: {
            value: "",
            isError: true,
            errorMessage: `and ARN code should  not match `,
          },
        });
      } else {
        this.setState({
          display: true,
        });
        const { communicationDetails, investorData } = this.props;
        const Xmobile = communicationDetails.find(
          (detail) =>
            detail.Fund === this.state.fund.value.value &&
            detail.Acno === this.state.folio.value.value &&
            detail.PAN === investorData.PAN &&
            !!detail.Mobile
        );
        const Xemail = communicationDetails.find(
          (detail) =>
            detail.Fund === this.state.fund.value.value &&
            detail.Acno === this.state.folio.value.value &&
            detail.PAN === investorData.PAN &&
            !!detail.email
        );

        const Email = !!Xemail && !!Xemail.email ? Xemail.email : "";
        const Mobile = !!Xmobile && !!Xmobile.Mobile ? Xmobile.Mobile : "";
        const selectedFund = funds.find(
          (i) => i.Fund === others.fund.value.value
        ).FundDesc;
        const params = {
          fundName: selectedFund,
          pan: investorData.PAN || this.props.user_pan,
          mobile: Mobile,
          email: Email,
          folio: this.state.folio.value.value,
          fund: this.state.fund.value.value,
          scheme:
            this.state.scheme.value.value.Sch ||
            this.state.scheme.value.value.fm_scheme,
          plan:
            this.state.scheme.value.value.Pln ||
            this.state.scheme.value.value.fm_plan,
          option:
            this.state.scheme.value.value.Opt ||
            this.state.scheme.value.value.fm_option,
          amount: this.state.amount.value,
          arnCode: this.state.arnCode.value,
          subArn: !!this.state.subArnCode.value
            ? `ARN-${subArnCode.value}`
            : "",
          subBroker: this.state.subBrokerCode.value,
          euin:
            this.state.radioValue.value === "yes"
              ? this.state.euinNo.value
              : "",
          euinDeclaration: this.state.radioValue.value === "yes" ? NO : YES,

          userId: this.state.arnCode.value, //this.props.userId,
          transactionType: singleTransaction.ADDITIONAL_PURCHASE_LUMPSUM,
          dcr: singleTransaction.DCR, //Imp
          investorName: investorData.invname,
          schemeName: this.state.scheme.value.label,
          category: this.state.category.value,
          combo: this.state.isCombo,
          purchaseType: this.state.schemeType,
        };
        if (btnLabel === SUBMIT) {
          this.props.history.replace(
            "/payment-options/additional-purchase/single",
            {
              requestBody: params,
            }
          );
        } else if (btnLabel === addToCart) {
          const res = await this.props.addItemsToCart(params);
          if (res) {
            const [newCartItem] = res.cartItems.sort(
              (item1, item2) =>
                Number(item2.cartItemId) - Number(item1.cartItemId)
            );
            this.setState({
              openDialog: true,
              cartId: res.bulkOrderId,
              ihno: newCartItem.ihno,
            });
          }
        }
        this.setState({
          display: false,
        });
      }
    } catch (error) {
      alert(error);
    }
  };

  ComboChange = () => {
    this.setState({
      isCombo: !this.state.isCombo
        ? window.confirm(
            "You have opted to do a Purchase cum Switch. Do you want to proceed?"
          )
        : false,
    });
  };

  render() {
    const {
      fund,
      reference_Number,
      radioValueforpayment,
      funds = [],
      folio,
      folios = [],
      schemeType,
      schemes = [],
      scheme,
      radioValue,
      arnCode,
      subArnCode,
      subBrokerCode,
      euinNo,
      categories,
      category,
      combo,
      isCombo,
      // bank,
      amount,
    } = this.state;
    const { euinList } = this.props;
    return (
      <div className="transaction-details">
        <CustomLoader display={!!this.state.display} />
        {/* <PosterDialog open={this.state.PosterOpen} close={this.closePoster} /> */}
        <div className="title">Additional Purchase</div>
        <div className="input-margin">
          <div className="input-name input-integrated-label">AMC</div>
          <IntegrationReactSelect
            suggestions={funds.map((item) => ({
              label: item.FundDesc,
              value: item.Fund,
            }))}
            value={fund.value}
            placeholder="Select Fund"
            handleChange={this.handleFundChange}
            inputRef={(ele) => (this.fundField = ele)}
            isError={fund.isError}
            errorMessage={fund.errorMessage}
          />
        </div>
        <div className="input-margin">
          <div className="input-name input-integrated-label">Folio</div>
          <IntegrationReactSelect
            suggestions={folios.map((item) => ({
              label: item,
              value: item,
            }))}
            // onKeyDown={evt => {
            //   if (
            //     !/^(0|[1-9][0-9]*)$/.test("" + evt.key) &&
            //     evt.key != "Backspace" &&
            //     evt.key != "Shift" &&
            //     evt.key != "ArrowLeft" &&
            //     evt.key != "ArrowRight"
            //   ) {
            //     evt.preventDefault();
            //   }
            // }}
            value={folio.value}
            placeholder="Select Folio"
            handleChange={this.handleFolioChange}
            inputRef={(ele) => (this.folioField = ele)}
            disabled={!fund.value}
            isError={folio.isError}
            errorMessage={folio.errorMessage}
          />
        </div>
        <div className="input-name">Select Scheme Type</div>
        <div className="radio-buttons-div">
          <Debtbutton
            buttontitle="Existing Scheme"
            width={150}
            active={schemeType === EXISTING}
            onClick={this.changeSchemeType(EXISTING)}
          />
          <Debtbutton
            buttontitle="New Scheme"
            width={150}
            active={schemeType === NEW}
            onClick={this.changeSchemeType(NEW)}
          />
        </div>
        {schemeType === NEW && (
          <div className="input-margin">
            <CustomizedSelect
              name="Category"
              bordercolor="#a6a6a6"
              handleChange={this.handleCategoryChange}
              value={category.value}
              disabled={!folio.value}
              placeholder="Select Category"
              inputRef={(ele) => (this.categoryField = ele)}
              isError={category.isError}
              borderColor="#a6a6a6"
              errorMessage={category.errorMessage}
            >
              {categories.map((item, index) => (
                <MenuItem value={item.CatValue} key={index}>
                  {item.CatDesc}
                </MenuItem>
              ))}
            </CustomizedSelect>
          </div>
        )}
        <div className="input-margin">
          <div className="input-name input-integrated-label">Scheme</div>
          <IntegrationReactSelect
            suggestions={schemes.map((item) => ({
              value: item,
              label: item.PlnDesc
                ? `${item.SchDesc1} - ${item.PlnDesc} - ${item.OptDesc}`
                : item.fm_schdesc,
            }))}
            value={scheme.value}
            placeholder="Select Scheme"
            handleChange={this.handleSchemeChange}
            disabled={!folio.value}
            inputRef={(ele) => (this.schemeField = ele)}
            isError={scheme.isError}
            errorMessage={scheme.errorMessage}
          />
        </div>
        {combo.flag === "Y" && (
          <div style={{ display: "flex", alignItems: "center", marginTop: 10 }}>
            <Checkbox
              onClick={this.ComboChange}
              value={combo.label}
              checked={isCombo}
              color="secondary"
            />
            <div
              style={{
                fontSize: 14,
                fontFamily: "OpenSans-Bold",
                color: "#283d7c",
              }}
            >
              {combo.label}
            </div>
          </div>
        )}
        {combo.flag === "Y" && (
          <div
            style={{
              color: "#283d7c",
              fontSize: 14,
              fontFamily: "OpenSans-SemiBold",
              margin: 10,
            }}
          >
            {combo.disclamier}
          </div>
        )}
        <div className="input-margin">
          <Input
            name="ARN Code"
            value={arnCode.value.split("-")[1]}
            disabled={true}
            bordercolor="#a6a6a6"
          />
        </div>
        <div className="input-margin">
          <Input
            name="Sub ARN Code"
            disabled={!fund.value}
            onKeyDown={(evt) =>
              (evt.key === "e" || evt.key === "." || evt.key === "-") &&
              evt.preventDefault()
            }
            type="number"
            value={subArnCode.value}
            isShowError={subArnCode.isError}
            errorMessage={subArnCode.errorMessage}
            onBlur={this.validateBrokerCode(
              fund.value ? fund.value.value.Fund : ""
            )}
            onChange={this.changeValue("subArnCode")}
            inputref={(ele) => (this.subArnField = ele)}
            bordercolor="#a6a6a6"
          />
        </div>
        <div className="input-margin">
          <Input
            name="Sub Broker Code"
            onKeyDown={(evt) =>
              (evt.key === "." || evt.key === "-") && evt.preventDefault()
            }
            value={subBrokerCode.value}
            onChange={this.changeValue("subBrokerCode")}
            inputref={(ele) => (this.subBrokerField = ele)}
            bordercolor="#a6a6a6"
          />
        </div>
        <div className="input-field-container ">
          <div className="input-name" style={{ marginBottom: 0 }}>
            EUIN
          </div>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="Search"
              name="search"
              value={radioValue.value}
              style={{ flexDirection: "row" }}
              onChange={this.changeValue("radioValue")}
            >
              <div className="investor-radio-button">
                <FormControlLabel
                  value="yes"
                  control={
                    <Radio
                      className="investor-search-radio"
                      style={{ color: "#007ac8" }}
                    />
                  }
                  className="investor-formcontrol-label"
                  style={{ margin: 0 }}
                />
                <div className="investor-form-label">YES</div>
              </div>
              <div className="investor-radio-button">
                <FormControlLabel
                  value="no"
                  control={
                    <Radio
                      className="investor-search-radio"
                      style={{ color: "#007ac8" }}
                    />
                  }
                  className="investor-formcontrol-label"
                  style={{ margin: 0 }}
                />
                <div className="investor-form-label">NO</div>
              </div>
            </RadioGroup>
          </FormControl>
        </div>
        {radioValue.value === "yes" ? (
          <div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 15,
              }}
            >
              <div
                className="investor-input-div"
                style={{ border: "1px black solid", height: "50px" }}
              >
                <SearchIcon className="investor-input-searchicon" />
                <InputBase
                  value={euinNo.value}
                  placeholder="Type here"
                  className="investor-input-inputbase"
                  onChange={(e) =>
                    this.setState({
                      euinNo: { value: e.target.value },
                      openeuin: true,
                    })
                  }
                />
              </div>
            </div>
            {euinList.length > 1 && this.state.openeuin && (
              <div className="dataResult">
                {euinList &&
                  euinList
                    .filter((ele) =>
                      ele.abm_agent
                        .toLowerCase()
                        .includes(euinNo.value.toLowerCase())
                    )
                    .map((ele) => (
                      <div>
                        <p
                          className="euin-item"
                          onClick={() => this.euinitem(ele.abm_name)}
                        >
                          {ele.abm_agent}
                        </p>
                      </div>
                    ))}
              </div>
            )}
            {this.state.erroreuin && !this.state.euinNo.value && (
              <div style={{ color: "red" }}>Euin Declaration is mandatory</div>
            )}
          </div>
        ) : (
          <div className="euin-text">
            I/We hereby confirm that the EUIN box has been intentionally left
            the blank by me/us as this is an 'execution-only' transaction
            without any interaction or advice by any personnel of the above
            distributor or notwithstanding the advice of in-appropriateness,if
            any provided by any personnel of the distributor and the distributor
            has not charged any advisory fees on this transaction
          </div>
        )}
        <div style={{ marginBottom: 20 }}>
          <Input
            name="Investment Amount(INR)"
            value={amount.value}
            label={this.state.minAmount}
            type="number"
            onKeyDown={(evt) =>
              (evt.key === "e" || evt.key === "." || evt.key === "-") &&
              evt.preventDefault()
            }
            onBlur={this.showError("amount")}
            onChange={this.changeValue("amount")}
            inputref={(ele) => (this.amountField = ele)}
            bordercolor="#a6a6a6"
            isShowError={amount.isError}
            errorMessage={amount.errorMessage}
            maxLength={9}
          />
        </div>
        {/* {!!showSmart && (
          <div className="input-field-container">
            <div
              className="input-name"
              style={{ fontFamily: "OpenSans-SemiBold", fontSize: 16 }}
            >
              Your investor is eligible for a SMART facility
            </div>

            <FormControl component="fieldset">
              <RadioGroup
                aria-label="Search"
                name="search"
                value={smart.flag}
                style={{ flexDirection: "row" }}
                onChange={this.changeSmart}
              >
                <div className="investor-radio-button">
                  <FormControlLabel
                    value="yes"
                    control={
                      <Radio
                        className="investor-search-radio"
                        style={{ color: "#007ac8" }}
                      />
                    }
                    className="investor-formcontrol-label"
                    style={{ margin: 0 }}
                  />
                  <div className="investor-form-label">YES</div>
                </div>
                <div className="investor-radio-button">
                  <FormControlLabel
                    value="no"
                    control={
                      <Radio
                        className="investor-search-radio"
                        style={{ color: "#007ac8" }}
                      />
                    }
                    className="investor-formcontrol-label"
                    style={{ margin: 0 }}
                  />
                  <div className="investor-form-label">NO</div>
                </div>
              </RadioGroup>
            </FormControl>
          </div>
        )} */}
        {this.props.token === "ARN-35783" &&
          this.state.fund.value.value === "178" && (
            <div>
              <div
                className="input-margin "
                style={{ display: "flex", flexDirection: "row", marginTop: 15 }}
              >
                <span style={{ paddingTop: 12 }}>BOB-PIO Payment Option:</span>
                <FormControl component="fieldset">
                  <RadioGroup
                    aria-label="Search"
                    name="search"
                    style={{ flexDirection: "row" }}
                    value={radioValueforpayment.value}
                    onChange={this.changeValue("radioValueforpayment")}
                  >
                    <div className="investor-radio-button">
                      <FormControlLabel
                        value="Y"
                        control={
                          <Radio
                            className="investor-search-radio"
                            style={{ color: "#007ac8" }}
                          />
                        }
                        className="investor-formcontrol-label"
                        style={{ margin: 0 }}
                      />
                      <div className="investor-form-label">Yes</div>
                    </div>
                    <div className="investor-radio-button">
                      <FormControlLabel
                        value="N"
                        control={
                          <Radio
                            className="investor-search-radio"
                            style={{ color: "#007ac8" }}
                          />
                        }
                        className="investor-formcontrol-label"
                        style={{ margin: 0 }}
                      />
                      <div className="investor-form-label">No</div>
                    </div>
                  </RadioGroup>
                </FormControl>
              </div>
              <div>
                {this.state.radioValueforpayment.value === "Y" && (
                  <div style={{ marginBottom: 20 }}>
                    <Input
                      name="Payment (pre-debit) Reference Number"
                      bordercolor="#a6a6a6"
                      placeholder="Enter the Reference Number"
                      isShowError={reference_Number.isError}
                      errorMessage={reference_Number.errorMessage}
                      onBlur={this.showError("reference_Number")}
                      value={reference_Number.value}
                      onChange={this.changeValue("reference_Number")}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
        <div className="trantype-button-view">
          {!(
            cartDisabledFunds.includes(
              this.state.fund.value.value?.toString()
            ) && this.state.isCombo
          ) ? (
            <Signbutton
              buttontitle="Add to cart"
              onClick={() => this.onButtonClick(`${addToCart}`)}
              width={240}
              border={"1px solid #007CC5"}
              texttransform={true}
            />
          ) : null}
          <span className="addtocart-btn" />
          <Signbutton
            buttontitle="Submit"
            onClick={() => this.onButtonClick(`${SUBMIT}`)}
            width={240}
            border={"1px solid #007CC5"}
            texttransform={true}
          />
        </div>

        <AddToCartStatusModal
          message={`Transaction has been added to cart successfully with the reference number ${this.state.ihno} and bulk-order ID ${this.state.cartId}`}
          closeModal={this.close}
          open={this.state.openDialog}
          image={"/images/cart_success.svg"}
          btn_one={"Go to cart"}
          btn_two={"Add more"}
          onAddTransaction={() =>
            this.props.history.push(
              "/cart/add-transaction/additional-purchase",
              {
                pan: this.props.investorData.PAN,
              }
            )
          }
          pan={this.props.investorData.PAN}
          ihno={this.state.ihno}
          cartId={this.state.cartId}
        />
      </div>
    );
  }
}

export default connect(
  ({ authReducer, transactions }) => {
    const {
      fundList,
      token,
      userId,
      bankDetails,
      investorData,
      communicationDetails,
      user_pan,
      isCartUser,
    } = authReducer;
    const { euinList } = transactions;
    return {
      isCartUser,
      fundList,
      token,
      userId,
      euinList,
      bankDetails,
      investorData,
      communicationDetails,
      user_pan,
    };
  },
  {
    validateSubBroker,
    getAssetClasses,
    getOtherSchemes,
    submitPurchaseData,
    showPurchaseConfirmation,
    addItemsToCart,
    additionalPurchase,
  }
)(AdditionalPurchase);
